import axios from "axios";
import { useContext, useEffect, useState } from "react";
import {
  redirect,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import "./style/CurrentService.css";
import { AuthContext } from "../auth/AuthProvider";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";
import RelifeContactNew from "../homeLayout/RelifeContactNew";

const FEATURES = [
  "Full access to all 5 phases of a theme",
  "25 carefully crafted reflection questions",
  "Audio reflections built around your answers",
  "Structured emotional journey — not random prompts",
  "Progress saved locally — continue any time",
  "Private by design — nothing leaves your device",
];
export default function CurrentService() {
  const { id } = useParams();

  const [theme, setTheme] = useState({});
  const [themeAccess, setThemeAccess] = useState({});
  const [servicePayment, setServicePayment] = useState(null);
  const [urlExists, setUrlExists] = useState(false);
  const navigate = useNavigate();

  const {
    loading,
    setLoading,
    authenticated,
    user,
    status,
    setStatus,
    paymentLocation,
    setPaymetLocation,
    payload,
    setPayload,
    setSessionId,
    sessionId,
    payed,
    prevLocation,
    storage,
    googleUser,
    themeCompletion,
    setPrevLocation,
    apiUrl,
    setError,
    setPayed,
    setPayedStressFatigue,
    payedStressFatigue,
  } = useContext(AuthContext);

  const location = useLocation();
  useEffect(() => {
    axios
      .get(`${apiUrl}/theme/${id}`)
      .then((response) => {
        setTheme(response.data);
      })
      .catch((e) => {
        console.error(e);
        setError(e.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (prevLocation.includes("/Phase 1/")) {
      localStorage.setItem("postLoginRedirectTheme", prevLocation);
    }
    if (!user && !googleUser) {
      localStorage.setItem("postLoginRedirect", location.pathname);
      return;
    }

    async function checkAccessAndRedirect() {
      try {
        const userType = user
          ? `username/${user.username}`
          : `googleEmail/${encodeURIComponent(googleUser.email)}`;

        const successRes = await axios.get(
          `${apiUrl}/success/${userType}/${id}`,
        );
        const hasAccess = successRes.data;

        const accessGranted = Array.isArray(hasAccess)
          ? hasAccess.length > 0
          : Boolean(hasAccess);

        setThemeAccess((prev) => ({
          ...prev,
          [id]: accessGranted,
        }));

        if (!accessGranted) return;

        const questionUrl = user
          ? `${apiUrl}/user-question/byUserAndTheme/${user.username}/${id}`
          : `${apiUrl}/user-question/byGoogleUserAndTheme/${encodeURIComponent(
              googleUser.email,
            )}/${id}`;

        const questionRes = await axios.get(questionUrl);
        const sorted = [...questionRes.data].sort(
          (a, b) => b.questionThemeIndex - a.questionThemeIndex,
        );

        if (sorted.length === 0) return;

        const latest = sorted[0];

        if (latest.answerLabel) {
          navigate(
            `/session/${latest.themeSlug}/${latest.phaseName}/${latest.hashed}/${latest.answerLabel}`,
          );
        } else {
          navigate(
            `/session/${latest.themeSlug}/${latest.phaseName}/${latest.hashed}`,
          );
        }

        localStorage.removeItem("postLoginRedirectTheme");
      } catch (err) {
        if (err.response?.status === 404) {
          setThemeAccess((prev) => ({
            ...prev,
            [id]: false,
          }));
          return;
        }

        console.error("checkAccessAndRedirect error:", err);
        setError(err.message);
      }
    }

    checkAccessAndRedirect();
  }, [user, googleUser, id]);

  async function Payment() {
    if (!user && !googleUser) {
      localStorage.setItem(
        "postLoginRedirect",
        location.pathname + location.search,
      );
      navigate("/login");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(`${apiUrl}/product/v1/checkout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: 499,
          quantity: 1,
          name: theme?.title,
          currency: "EUR",
          slug: theme?.slug,
          redirect:
            localStorage.getItem("postLoginRedirectTheme") ||
            prevLocation.includes("/Phase 1/")
              ? "phase1"
              : // redirect:
                "success",
          ...(user && { username: user.username }),
          ...(googleUser && { googleEmail: googleUser.email }),
        }),
      });

      if (!res.ok) {
        const errorText = await res.text();
        console.error("Checkout failed:", errorText);
        setLoading(false);
        return;
      }

      const data = await res.json();

      setStatus(data?.status);
      setSessionId(data?.sessionId);

      if (data?.sessionUrl) {
        setServicePayment(data);
        setPaymetLocation(data.sessionUrl);

        // Redirect to Stripe
        window.location.href = data.sessionUrl;
      } else {
        setLoading(false);
        setUrlExists(false);
      }
    } catch (e) {
      console.error("Payment error:", e);
      setLoading(false);
    }
  }

  if (loading || !theme?.id) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <div className="main" id="service-new">
        <div
          style={{
            textAlign: "center",
            fontSize: "100px",
            margin: "0 0",
            padding: "1rem 0",
          }}
        >
          Choose Your Pricing Plan
        </div>
        <section className="services" id="service">
          <>
            <div className="service-card" id="service-card-new">
              <h2>{theme.title}</h2>
              <h2 className="pricing-card-name">Full Theme Access</h2>
              <p className="pricing-card-desc">
                Complete guided reflection journey — 5 phases, 25 questions,
                calm audio insights built around your answers.
              </p>

              <div className="pricing-amount">
                <div className="pricing-price">€4.99</div>
              </div>
              <div className="pricing-amount">
                <div className="pricing-price-note">one-time per theme</div>

                <>
                  <div className="pricing-card-features">
                    <ul className="pricing-feature-list">
                      {FEATURES.map((f) => (
                        <li key={f} className="pricing-feature">
                          <span className="pricing-feature-dot" />
                          {f}
                        </li>
                      ))}
                    </ul>
                  </div>
                </>

                <button
                  id="pricing-cta"
                  className="pricing-cta"
                  onClick={Payment}
                >
                  Unlock Full Access ($4.99)
                </button>
              </div>
            </div>
          </>
        </section>
      </div>

      <RelifeContactNew />
    </>
  );
}
